import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { BrandLogo } from "@/components/ui/BrandLogo";

export function HomeFooter() {
  const { t } = useTranslation("home");

  return (
    <footer className="border-t border-home-ink/10 px-5 py-12">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-6 md:flex-row">
        <div className="flex items-center gap-2.5">
          <BrandLogo markClassName="h-7" />
          <span className="font-body text-sm text-home-ink/65">{t("footer.tagline")}</span>
        </div>

        <div className="flex items-center gap-6 font-body text-sm font-medium text-home-ink/65">
          <Link to="/privacy" className="inline-flex items-center px-1 py-2 transition-colors hover:text-home-ink">
            {t("footer.privacy")}
          </Link>
          <Link to="/terms" className="inline-flex items-center px-1 py-2 transition-colors hover:text-home-ink">
            {t("footer.terms")}
          </Link>
          <Link
            to="/login"
            search={{ pendingCode: undefined }}
            className="inline-flex items-center px-1 py-2 transition-colors hover:text-home-ink"
          >
            {t("footer.login")}
          </Link>
        </div>

        <p className="font-body text-[13px] text-home-ink/65">
          {t("footer.copyright")}
        </p>
      </div>

      {/* There's an AI for That verification badge. MUST stay on `/` only —
          their crawler verifies one URL, and a badge repeated site-wide can
          verify the wrong page. This component is mounted solely by
          routes/index.tsx, which is what keeps that true; do NOT lift it into
          a shared layout, and do NOT mirror it into index.html's <noscript>
          (vercel.json rewrites every path to `/`, so that block ships on
          every URL). The ?v= token in the href is the account-specific
          verification key — it is what their crawler matches on. */}
      <div className="mx-auto mt-10 flex max-w-6xl justify-center md:justify-start">
        <a
          href="https://theresanaiforthat.com/ai/clawcraft/?ref=featured&v=12257209"
          target="_blank"
          rel="nofollow noopener noreferrer"
        >
          <img
            src="https://media.theresanaiforthat.com/featured-on-taaft.png?width=600"
            alt={t("footer.taaftBadgeAlt")}
            width={300}
            height={63}
            className="h-auto w-[300px]"
          />
        </a>
      </div>
    </footer>
  );
}
